module.exports = __webpack_public_path__ + "static/pandecoco-c9b41a7e6c4e8d2a176a83efe0a32791.jpg";